module.exports = __webpack_public_path__ + "static/media/car.b7889250.jpg";